import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { Course } from "src/app/interfaces/response";
import { EntityService } from "src/app/services/entity.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-entidades-table-principal",
  templateUrl: "./entidades-table-principal.component.html",
  styleUrls: ["./entidades-table-principal.component.css"],
})
export class EntidadesTablePrincipalComponent implements OnInit {
  displayedColumns: string[] = ["nombreCurso", "capacitador", "estandares"];
  dataSource = new MatTableDataSource<Course>();
  totalElements: number = 0;
  pageSize: number = 30;
  pageNumber: number = 0;
  code: string = "";
  filterTimeout: any;
  activeEror: boolean;
  debounceTimer: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Output() courseSelected = new EventEmitter<Course>();

  constructor(private service: EntityService, private router: Router) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.getEntities(this.pageNumber, this.pageSize, this.code);
  }

  public sectorByID(entity: any): void {
    this.router.navigate(["/detalleEntidad", entity.prestadorServicio]);
  }

  public standarById(entity: any): void {
    localStorage.setItem("standard", entity.razonSocial);
    this.router.navigate(["/estandaresEntidad", entity.prestadorServicio]);
  }

  public onPageChange(event: PageEvent): void {
    this.getEntities(event.pageIndex, event.pageSize, this.code);
  }

  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.getEntities(0, this.pageSize, filterValue);
    }, 800);
  }


  private async getEntities(
    pageNumber: number,
    size: number,
    code: string
  ): Promise<void> {
    try {
      const entities = await this.service.getEntityList(
        pageNumber,
        size,
        code
      );
      if (!entities.content || entities?.content?.length === 0) {
        this.activeEror = true;
      } else {
        this.activeEror = false;
      }
      this.totalElements = entities.totalElements;
      this.dataSource.data = entities.content;
    } catch (error) {
      console.error("Error al obtener cursos:", error);
    }
  }
}
